<template>
    <div class="spark-docs-banner">
        <div class="spark-docs-banner__content">
            <div class="content__title">Spark Docs</div>

            <p class="content__description">
                Быстрее, проще, безопаснее — Ваш путь к цифровому документообороту!
            </p>
        </div>

        <img class="spark-docs-banner__img" alt="Spark Docs" src="/banners/spark-docs-banner.png" draggable="false" />
    </div>
</template>